import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abe222bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-block" }
const _hoisted_2 = { class: "name-title" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "progress-edit" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"progress-parent\" data-v-abe222bc><span class=\"progress-left\" data-v-abe222bc><span class=\"progress-bar border-primary\" data-v-abe222bc></span></span><span class=\"progress-right\" data-v-abe222bc><span class=\"progress-bar border-primary\" data-v-abe222bc></span></span></div>", 1)
const _hoisted_6 = { class: "progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center" }
const _hoisted_7 = { class: "progress-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.message), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["block-content", _ctx.isMobileDevice ? 'row no-margin' : 'block-flex'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["name-text", _ctx.isMobileDevice ? 'col-9' : ''])
      }, _toDisplayString(_ctx.displayVal), 3),
      _createElementVNode("div", {
        id: _ctx.editButtonId,
        class: _normalizeClass(["edit-btn-container", _ctx.isMobileDevice ? 'col-2' : '']),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickEditQuestion && _ctx.onClickEditQuestion(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getUiText("app-nav-link-edit-1")), 1)
          ])
        ])
      ], 10, _hoisted_3)
    ], 2)
  ]))
}